import './CreatedDate.scss';
import React, { useState } from 'react';
import block from 'bem-cn-lite';
import {Text, Tooltip} from '@gravity-ui/uikit';
import {formatDate} from '@utils';
import {useMediaQuery} from 'react-responsive';

const b = block('created-date');

export interface CreatedDateProps {
    value: Date;
    className?: string;
    isCustomOrder?: boolean;
}

export const CreatedDate: React.FC<CreatedDateProps> = ({value, className, isCustomOrder}) => {
    const isMobileScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [dateStr, timeStr] = formatDate(value, ['DD.MM.YY', 'HH:mm']) as string[];
    const [openTooltip, setOpenTooltip] = useState(false);
    const showMobileTooltip = isCustomOrder && isMobileScreen;

    const handleDateClick = () => {
        setOpenTooltip(true);
        // setTimeout(() => setOpenTooltip(false), 3000);
    };

    const dateText = (
        <Text variant={'body-2'} color={'primary'}>
            {dateStr}
        </Text>
    );

    return (
        <div className={`${b()} ${className}`}>
            {showMobileTooltip ? (
                <Tooltip
                    content={<Text variant={'body-1'}>Дата заказа</Text>}
                    contentClassName={b('label-tooltip')}
                    className={b('label-tooltip-container')}
                    placement="top-start"
                    openDelay={0}
                    closeDelay={0}
                    disabled={!openTooltip}
                >
                    <div
                        className={b('date-trigger')}
                        onClick={handleDateClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                handleDateClick();
                            }
                        }}
                    >
                        {dateText}
                    </div>
                </Tooltip>
            ) : (
                dateText
            )}
            {!isMobileScreen && (
                <Text variant={'body-2'} color={'secondary'}>
                    {timeStr}
                </Text>
            )}
        </div>
    );
};
